import { Controller, useForm } from "react-hook-form";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import { Box, DialogContent } from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth0 } from "@auth0/auth0-react";
import DataGrid from "../../../components/DataGrid/DataGrid.tsx";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import { format, parseISO } from "date-fns";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import { StyledDataGrid } from "../../../components/StyledComponents/DataGrid/StyledDataGrid.tsx";

const JobsHeader = ({ setOpen }) => {
  const { setJobs } = useMinerPageContext();
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
      >
        <H6HeadlineSmall>{"Job history"}</H6HeadlineSmall>

        <BodyMedium>
          Use this window to view the latest jobs on the
          miner.
        </BodyMedium>
      </Box>

      <StyledIconButton 
        colors={colors}
        onClick={() => {
          setOpen(false);
          setJobs([]);
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

const displayTS = (updatedAt) => {
  const isoDate = updatedAt;
  const localDate = new Date(isoDate);
  const nowDate = Date.now();
  const diffTime = Math.abs(nowDate - localDate); // diffTime in milliseconds

  return { diffTime: diffTime, timeStr: localDate.toLocaleString() };
};

const JobsForm = ({ setOpen }) => {
  const { colors } = useTheme();
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const { jobs } = useMinerPageContext();
  console.log("JobsForm", jobs);

  const closeDialog = async (data) => {
    setOpen(false);
  };

  const columns = [
    {
      field: "jobId",
      headerName: "ID",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "user",
      headerName: "User",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "command",
      headerName: "Commands",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "response",
      headerName: "Response",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        if (!params.value) return null;
        const { diffTime, timeStr } = displayTS(params.value);
        if (timeStr){
          return (
            <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {timeStr}
            </div>
          );
        } else {
          return null;
        }
      }
    },
  ];

  const operationLogsModified =
    jobs &&
    Array.isArray(jobs) &&
    jobs.length > 0 &&
    jobs.map((log, index) => ({
      id: index + 1,
      jobId: log?.jobid,
      user: log?.user,
      command: log?.command,
      response: log?.response,
      updatedAt: log?.updatedAt,
    }));
  console.log(
    "operationLogsModified",
    operationLogsModified
  );

  const dataGridProps = {
    rows: operationLogsModified || [],
    columns: columns,
    autoHeight: true,
    hideFooter: true,
    getRowId: (row) => row.id,
    getRowHeight: () => "auto",
  };

  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
  }, [getAccessTokenSilently]);

  return (
    <>
      <JobsHeader setOpen={setOpen} />

      <Box display={"flex"} flexGrow={1}>
        {jobs &&
          Array.isArray(jobs) &&
          jobs.length > 0 &&  
          columns.length > 0 && (
            <>
              {" "}
              <StyledDataGrid
                colors={colors}
                {...dataGridProps }
                height={"50vh"}
                maxHeight="50vh"
                sx={{
                  "& .MuiDataGrid-cell": {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    display: "flex",
                    alignItems: "flex-start",
                  },
                }}
              />
            </>
          )}
      </Box>
    </>
  );
};

const JobsDialog = ({ open, setOpen }) => {
  const { colors } = useTheme();
  return (
    <StyledDialog
      colors={colors}
      maxWidth={"xl"}
      fullWidth
      open={open}
      hideBackdrop
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          setOpen(false);
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <JobsForm setOpen={setOpen} />
      </DialogContent>
    </StyledDialog>
  );
};

export default JobsDialog;
